module.exports = __webpack_public_path__ + "img/seg2.9b9eb86f.jpg";